import { render, staticRenderFns } from "./PreviewPage.vue?vue&type=template&id=0b360d4c&scoped=true"
import script from "./PreviewPage.vue?vue&type=script&lang=js"
export * from "./PreviewPage.vue?vue&type=script&lang=js"
import style0 from "./PreviewPage.vue?vue&type=style&index=0&id=0b360d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b360d4c",
  null
  
)

export default component.exports